// extracted by mini-css-extract-plugin
module.exports = {"footerContainer":"ClientWallet_footerContainer__1SkZ9","savePackageButton":"ClientWallet_savePackageButton__7QVH9"};